module.exports = __webpack_public_path__ + "img/@logo_mindslab.ec416b36.jpg";